import FormRegister from "../../components/FormRegister";
import Layout from "../../components/Layout";
import NavigationMain from "../../components/NavigationMain";

function Register() {
  return (
    <>
      <NavigationMain />
      <Layout>
        <FormRegister />
      </Layout>
    </>
  );
}

export default Register;
